import { useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { caseApplicationsService, GET_PINNED_CASES } from '@/api';
import { ErrorHttpResponse } from '@/interfaces';
import { formatErrorMessage } from '@/lib';
import { useNotification } from '@/hooks/useNotification';

export const useTogglePinCase = (refetchCase: () => void) => {
	const queryClient = useQueryClient();
	const { toastError } = useNotification();
	const pinningIds = useRef(new Set<string>());

	const togglePinCase = async (caseId: string) => {
		if (pinningIds.current.has(caseId)) return;
		pinningIds.current.add(caseId);
		try {
			await caseApplicationsService.togglePinCase(caseId);
			refetchCase();
			queryClient.refetchQueries({ queryKey: [GET_PINNED_CASES] });
		} catch (error) {
			toastError(formatErrorMessage((error as ErrorHttpResponse)?.message));
		} finally {
			pinningIds.current.delete(caseId);
		}
	};

	return { togglePinCase };
};
